<template>
  <div class="container-fluid mini-profile-1">
    <div class="row align-items-center">
      <div class="col-4">
        <img class="img-fluid w-100  h-100" :src="profileImage" :alt="profile.name">
      </div>
      <div class="col-8">
        <p>{{profile.name}} {{profile.last_name}}</p>
        <p>{{ profile.cellphone}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import {mapGetters} from "vuex";
import {userAvatar} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/User";

export default defineComponent({
  name: "MiniProfile1",
  computed: {
    ...mapGetters({
      profile: 'User/getProfile'
    }),
    profileImage() {
      const profileImage = this.profile.image
      if (profileImage == null) {
        return userAvatar
      }
      return profileImage
    }
  }
})
</script>


<style scoped>

</style>